export const borderClassesError = [
  'border-error-300',
  'focus-visible:border-error-600',
  'focus-visible:ring-error-600',
]
